/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type NexonLwOverviewInfo = {
    NM: string;
    SB: string;
    IMG: string;
    CS: string;
    MS: string;
    MC: string;
    FDV: string;
    UNLPRGPER: string;
    DSTP: NexonLwOverviewInfo.DSTP;
    LSTUPD: number;
};

export namespace NexonLwOverviewInfo {

    export enum DSTP {
        NORMAL = 'NORMAL',
        WARNING = 'WARNING',
        PENDING = 'PENDING',
    }


}

